// Funzione che crea il pdf con un coupon di sconto da distribuire
// a un utente per la sua prossima submission list
import {jsPDF} from "jspdf";
import 'jspdf-autotable'
import I18n from 'i18n.js.erb'
import {koruri} from "./Koruri-Regular-normal";
import {koruriBold} from "./Koruri-Bold-normal";
import { CURRENCY_EURO } from "../utils";


const tab = "        "
const space = " "

const writeBoldText = (jsPDFDocument, text, xPosition, yPosition) => {
  jsPDFDocument.setFont('Helvetica', '', 'Bold')
  jsPDFDocument.text(text, xPosition, yPosition)
  jsPDFDocument.setFont('Helvetica', '', '')
}

const addFrame = (doc) => {
  const pageCount = doc.internal.getNumberOfPages()
  for (var i = 1; i <= pageCount; i++) {
    doc.setPage(i)
    doc.setDrawColor(4, 159, 227)
    doc.rect(5, 5, doc.internal.pageSize.width - 10, doc.internal.pageSize.height - 10)
  }
}


const writeItalicText = (jsPDFDocument, text, xPosition, yPosition) => {
  jsPDFDocument.setFont('Helvetica', 'italic')
  jsPDFDocument.text(text, xPosition, yPosition)
  jsPDFDocument.setFont('Helvetica', '', '')
}

const centerString = (pageWidth, txt, doc) => {
  var fontSize = doc.internal.getFontSize();
  const stringLength = doc.getStringUnitWidth(txt) * fontSize / doc.internal.scaleFactor;
  return (pageWidth - stringLength) / 2
}




export const voucherPDF = (voucher) => {

  const doc = new jsPDF('l', 'pt', 'a7');
  doc.addFileToVFS("Koruri-Regular.ttf", koruri);
  doc.addFont("Koruri-Regular.ttf", "Koruri-Regular", "normal");
  doc.addFileToVFS("Koruri-Bold-normal.ttf", koruriBold);
  doc.addFont("Koruri-Bold-normal.ttf", "Koruri-Bold", "bold");
  doc.setFont('Helvetica')

  const pageWidth = doc.internal.pageSize.width

  var img = new Image()
  img.src = '/images/logo-AIGRADING-white.png'
  doc.addImage(img, (pageWidth / 2) - 50, 13, 100, 25)

  doc.setFontSize(16)
  doc.setTextColor(4, 159, 227)

  var discount = voucher.amount ? voucher.amount.toString() + CURRENCY_EURO : voucher.percentage.toString() + '%'
  const line1 = discount + space + I18n.t('js.PDFGenerator.voucher.discount').toUpperCase()
  writeItalicText(doc, line1, centerString(pageWidth, line1, doc), 90)

  const line2 = I18n.t('js.PDFGenerator.voucher.onYourNextSubmission').toUpperCase()
  writeItalicText(doc, line2, centerString(pageWidth, line2, doc), 110)

  doc.setTextColor(0, 0, 0)

  const line3 = I18n.t('js.PDFGenerator.voucher.discountCode') + ':'
  writeBoldText(doc, line3, centerString(pageWidth, line3, doc), 165)

  writeBoldText(doc, voucher.code, centerString(pageWidth, voucher.code, doc), 190)

  addFrame(doc)
  var pdfName= `Coupon_${voucher.code}.pdf`
  doc.save(pdfName);
}
